export function Tip() {
  return (
    <div>
      <h1>Bon à savoir</h1>
      <h2>Qui peut adhérer au contrat Pavixie ?</h2>
      <p>
        La souscription au contrat Pavixie est ouverte aux personnes physiques
        de moins de 76 ans et domiciliées en France.
      </p>
    </div>
  );
}
